export const getGiftCardToken = (state: WtrState) => state.order?.giftCardToken;
